export interface ValidationComponentType {
	key: string;
	label: string;
	type: string;
	enum?: string[];
	inputMode?: string;
}

const defaultValComponents = [
	{
		key: 'label',
		type: 'text',
		label: 'Field Label',
	},
	{
		key: 'placeholder',
		type: 'text',
		label: 'Placeholder',
	},
	{ key: 'required', type: 'switch', label: 'Required' },
	{ key: 'helpText', type: 'text', label: 'Help Text' },
	{
		key: 'dependsOn',
		type: 'dependsOn',
		content: { value: '' },
		label: 'Depends On',
	},
	{ key: 'parent', type: 'switch', label: 'Parent' },
];
export default defaultValComponents;
